import axios from "@/api/axios";

async function sendSetGuidsRequest() {
  let updatedJsonObj = null;
  let url = "/api/inputJson/setGuids";
  console.log("sendSetGuidsRequest");
  try {
    let data = {
      patientId: vueApp.patientId,
      jsonPath: vueApp.jsonLocation,
    };
    var stringData = JSON.stringify(data);
    var config = {};
    config.headers = {
      "content-type": "application/json",
    };
    const response = await axios.post(url, stringData, config);
    console.log("sendSetGuidsRequest response", response);
    if (response && response.data && response.data.value) {
      updatedJsonObj = JSON.parse(response.data.value);
    }
  } catch (e) {
    console.log("sendGetPdfReportDataRequest error", e);
  }
  return updatedJsonObj;
}

export { sendSetGuidsRequest };
